<template>
    <div class="container">
      <div id="div_banner" class="banner1">
        <img src="../../assets/jishu.png" alt="技术服务">
        <div>
          <p>技术服务</p>
          <span>Technical Services</span>
        </div>
<!--        <img  v-if="imgUrl"  :src="baseUrl+imgUrl"  alt="技术服务" height="190">-->

      </div>
      <div class="s1">
        <div class="box">
          <div id="techincal_team" class="title tbg">
            <h2>技术专家团队</h2>
            <h3>TECHNICAL EXPERT TEAM</h3>
          </div>
          <div class="s1_main">
            <div id="div_team" class="top">公司主要为政府和企业提供全面的“数字化改革”整体解决方案服务，并专注于物流园区、物流企业的产品研发，为物流产业互联，园区互通提供产品。</div>
            <div id="div_expert" class="wrap">
              <div class="s1_list clearfix" v-for="item in TeamData">
                <div class="pic_box fl">
                  <img :src="baseUrl + item.fteamUrl" alt="首席科学家">
                </div>
                <div class="text fr">
                  <h2>{{item.fteamCall}}<span>{{item.fteamName}}</span></h2>
                  <div>
                    <span style="color:#333333;line-height:30px;font-family:微软雅黑, sans-serif;font-size:14px;background-color:#E5E5E5;" >
                      <p class="MsoNormal" v-html="item.fteam" >
                      </p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="s3_main clearfix" v-html="TeamProjectData.fteamItem">
            </div>
          </div>
        </div>
      </div>
<!--      <div class="s3">-->
<!--        <div class="box">-->
<!--          <div id="platform_idea" class="title tbg">-->
<!--            <h2>IT专家云服务平台理念</h2>-->
<!--            <h3>IT EXPERT CLOUD SERVICE PLATFORM CONCEPT</h3>-->
<!--          </div>-->
<!--          <div class="s3_main clearfix">-->
<!--            <img src="../../assets/serve.jpg">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
</template>

<script>
  import axios from '../../../static/js/commonAxios'
    export default {
      name: "technical-service",
      data(){
        return{
          TeamData:[],
          TeamProjectData:'',
          baseUrl:'',
          imgUrl:'',//头部图
        }
      },
      mounted(){
        this.baseUrl = process.env.API_ROOT;
        this.getbar()
        this.getTeamData()
        this.getTeamProjectData()
      },
      methods:{
        getbar(){
          axios.get('/api/bar').then((res) => {
            if(res.data.success){
              let item=res.data.items
              item.forEach(arr=>{
                if(arr.fbar==='技术服务'){
                  this.imgUrl =  arr.fbarUrl
                  console.log(this.imgUrl);
                }
              })
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
        getTeamData(){
          axios.get(`/api/team`).then((res) => {
            if(res.data.success){
              this.TeamData = res.data.items
              console.log(this.TeamData);
            }else{
              this.$message({
                type: 'warning',
                message: res.data.msg
              });
            }
          })
        },
        getTeamProjectData(){
          axios.get(`/api/team/item`).then((res) => {
            if(res.data.success){
              this.TeamProjectData = res.data.items?res.data.items[0]:''
              console.log(this.TeamProjectData);
            }else{
              this.$message({
                type: 'warning',
                message: res.data.msg
              });
            }
          })
        },
      }
    }
</script>

<style scoped>
  .title{
    text-align: center;
    background: url(../../assets/2.png) no-repeat center 15px;
  }
  .title h2{
    font-size: 30px;
    color: #333333;
  }
  .title h3{
    font-size: 14px;
    color: #666666;
    margin-top: 10px;
  }
  .tbg {
    background: url(../../assets/60.png) no-repeat center 15px;
  }
  .s1{
    width: 100%;
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .s1 .s1_main{
    width: 100%;
    margin-top: 60px;
  }
  .s1 .s1_main .top{
    width: 640px;
    margin: 0 auto;
    text-align: center;
    font-size: 14px;
    color: #333;
    line-height: 30px;
  }
  .s1 .s1_main .wrap{
    width: 100%;
    margin-top: 60px;
  }
  .s1 .s1_main .wrap .s1_list{
    width: 100%;
    background: #e5e5e5;
    height: 360px;
    margin-bottom: 20px;
  }
  .s1 .s1_main .wrap .s1_list .pic_box{
    width: 440px;
    height: 360px;
    overflow: hidden;
  }
  .s1 .s1_main .wrap .s1_list .pic_box img{
    width: 100%;
  }
  .s1 .s1_main .wrap .s1_list .text{
    width: 600px;
    height: 205px;
    padding: 25px 80px 0;
  }
  .s1 .s1_main .wrap .s1_list .text h2{
    font-size: 18px;
    color: #36395a;
    background: url(../../assets/50.jpg) no-repeat left bottom;
    font-weight: bold;
  }
  .s1 .s1_main .wrap .s1_list .text h2 span{
    color: #363a5a;
    font-size: 18px;
    padding-left: 20px;
    background: url(../../assets/51.jpg) no-repeat left center;
    margin-left: 20px;
    font-weight: normal;
  }
  .s1 .s1_main .wrap .s1_list .text div{
    font-size: 14px;
    color: #333;
    line-height: 30px;
    margin-top: 5px;
  }
  /*.s1 .s1_main .wrap .s1_list .text .MsoNormal span{*/
  /*  font-size: 16px!important;*/
  /*}*/
  .s3{
    width: 100%;
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .s3 .s3_main{
    width: 100%;
    margin: 60px auto 0;

  }
  .s3 .s3_main img{
    display: block;
    width: 100%;
  }

  @media screen and (max-width: 1024px){
    .s1 .s1_main .wrap .s1_list .pic_box {
      width: 40%;
    }
    .s1 .s1_main .wrap .s1_list .text {
      width: 55%;
      padding: 15px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/technicalService/technicalService.vue